module.exports = __webpack_public_path__ + "assets/img/amplification.b2ce10bf.png";